import { useCurrentEditor } from '@tiptap/react';
import classNames from 'classnames';
import { useMemo, useState } from 'react';
import Menu from '../Menu';
import LinkInput from '../Menu/LinkInput';
import { getMenuActions } from './Actions';
import shouldShow from './helper/shouldShow';
import BubbleMenu from './style/BubbleMenu';

const FormattingMenu = () => {
  const { editor } = useCurrentEditor();
  const [linkModalVisible, setLinkModalVisible] = useState(false);

  const actions = useMemo(() => (editor ? getMenuActions({ editor, setLinkModalVisible }) : []), [editor]);

  return (
    <BubbleMenu
      className={classNames({ 'opacity-0': !(editor.isFocused || linkModalVisible) })}
      tippyOptions={{ maxWidth: '100%', placement: 'top' }}
      shouldShow={({ editor: shouldShowEditor }) => shouldShow(shouldShowEditor.state, shouldShowEditor.view)}
    >
      {(editor.isFocused || linkModalVisible) && <Menu actions={actions} className='d-flex align-items-center' />}
      {linkModalVisible ? (
        <LinkInput editor={editor} setLinkModalVisible={setLinkModalVisible} linkModalVisible={linkModalVisible} />
      ) : null}
    </BubbleMenu>
  );
};

export default FormattingMenu;
